import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, } from '@material-ui/core';


class SubscribeItem extends React.Component {

    constructor(props) {
        super(props);
    }


    _onClick = () => {
        this.props.onClick && this.props.onClick();
    }

    render() {
        const { classes, data, selected, nochan, mark } = this.props;
        return (
            <ButtonBase className={classes.buttonBase} onClick={() => this._onClick()}>
                <Grid container direction='column' alignItems='center' justify='center' className={selected ? classes.rootSelected : classes.root}>
                    <img src={data.logo} className={classes.img}></img>
                    <Typography className={classes.contentText}>{data.name}</Typography>
                    {
                        !nochan && <Typography className={classes.subTitle}>{data.count + '场'}</Typography>
                    }
                    {
                        mark && data.count != 0 && <Grid
                            container
                            direction='column'
                            alignItems='center'
                            justify='center'
                            style={{
                                backgroundColor: '#FC3035', width: 20, height: 20, borderRadius: 10, position: 'absolute', right: 0, top: 0
                            }}>
                            <Typography style={{ color: '#FFF', fontSize: 12 }}>{data.count}</Typography>
                        </Grid>
                    }
                </Grid>
            </ButtonBase>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: 78,
        height: 78,
        borderRadius: 10,
        backgroundColor: '#F5F5F5'
    },
    rootSelected: {
        width: 80,
        height: 80,
        borderRadius: 10,
        backgroundColor: '#EDEAFD',
        border: 'solid 1px ' + theme.palette.primary.main
    },
    img: {
        height: 26,
        width: 26,
        marginTop: 4,
        objectFit: 'scale-down',
    },
    contentText: {
        color: '#0D0D0D',
        fontSize: 12,
        marginTop: 4,
    },
    subTitle: {
        color: '#878787',
        fontSize: 10,
        marginTop: 4,
        marginBottom: 4,
    },
    buttonBase: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0)
    },
}))(SubscribeItem));